module.exports = __webpack_public_path__ + "static/media/button-icon.6a66bb6a.svg";